// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// Sentry (glitchtip) временно отключён — раскомментировать блок ниже, когда снова понадобится.

// import * as Sentry from "@sentry/nextjs";
//
// Sentry.init({
//     dsn: "https://5e9a1df8a69e45a8be3c162284d603c2@glitchtip.aerobic.space/1",
//
//     // Add optional integrations for additional features
//     integrations: [
//         Sentry.replayIntegration(),
//     ],
//
//     // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
//     tracesSampleRate: 1,
//     // Enable logs to be sent to Sentry
//     enableLogs: true,
//
//     // Define how likely Replay events are sampled.
//     // This sets the sample rate to be 10%. You may want this to be 100% while
//     // in development and sample at a lower rate in production
//     replaysSessionSampleRate: 0.1,
//
//     // Define how likely Replay events are sampled when an error occurs.
//     replaysOnErrorSampleRate: 1.0,
//
//     // Setting this option to true will print useful information to the console while you're setting up Sentry.
//     debug: false,
//
//     normalizeDepth: 10,          // default is ~3
//     normalizeMaxBreadth: 200,    // default is small
// });
//
// export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

export {};
